/* eslint-disable no-prototype-builtins */
/* eslint-disable react/no-did-update-set-state */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-return-assign */
import { Form, Formik } from 'formik';
import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { isEqual } from 'lodash';
import { FooterStyle } from './modal.style';
import Button from '../Button/button.component';
import WidgetDialog from '../Dialog/dialog.component';
import Subtitle from '../Subtitle/subtitle.component';

export const ModalFormContext = React.createContext({
	errors: null,
	touched: null,
	values: null,
	handleChange: null,
	setFieldValue: null,
});

class WidgetModalForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isCancelConfirmOpen: false,
			objectInitialValue: {},
		};
	}

	componentDidMount() {
		this.setState({
			objectInitialValue: {
				...this.props.initialValues,
			},
		});
	}

	/*
	 * Função para checar se valores foram alterados ou inserido nos forms do sistema
	 * Caso positivo, ele confirma se o usário quer mesmo sair e avisa que os dados serão perdidos
	 * Caso contrário, apenas sai ou fecha a modal
	 */
	checkIsDirty(values) {
		const { objectInitialValue } = this.state;

		/* Para o caso de cancelar alerta */
		if (objectInitialValue.hasOwnProperty('tipoStatusAlerta') && objectInitialValue.justificativaStatus === values.justificativaStatus) {
			return false;
		}

		/* Para o caso de cessar alerta */
		if (objectInitialValue.hasOwnProperty('tipoStatusAlerta') && objectInitialValue.mensagem === values.mensagem) {
			return false;
		}

		/* Para os demais casos, o segundo teste, é para o caso de não haver valores no values */
		if (isEqual(objectInitialValue, values) || (values.length === 0)) {
			return false;
		}
		return true;
	}

	render() {
		const {
			modalConfirmarCancelarTitulo,
			modalConfirmarCancelarCorpo,
			children,
			initialValues,
			validationSchema,
			title,
			confirmar,
			cancelar,
			textConfirmar,
			textCancelar,
			isOpen,
			iconCancelar,
			iconConfirmar,
			size,
			isVisualizarTransacao,
			dataAlteracao,
		} = this.props;
		return (
			<React.Fragment>
				<Modal isOpen={isOpen} size={size || 'lg'}>
					<ModalHeader
						toggle={() => (this.getContext()
							? this.setState({
								isCancelConfirmOpen: true,
							})
							: cancelar())
						}
					>
						<Subtitle>{title}</Subtitle>
					</ModalHeader>
					<ModalBody>
						<Formik
							initialValues={initialValues || []}
							enableReinitialize
							validationSchema={validationSchema || null}
							onSubmit={(values, options) => {
								if (confirmar) confirmar(values, options);
							}}
						>
							{ctx => (
								<Form>
									<ModalFormContext.Provider value={ctx}>
										<div>
											{/*
												Retorna o ctx do formik, para fora dele.
												Usado para saber se o cancelar de uma página, terá confirmação
												ou não, de acordo se o campo foi 'sujo' ou não.
											*/}
											{this.getContext = () => this.checkIsDirty(ctx.values)}
											{React.cloneElement(children)}

											<FooterStyle>
												<Button
													onClick={() => (this.checkIsDirty(ctx.values)
														? this.setState({
															isCancelConfirmOpen: true,
														})
														: cancelar())
													}
													cancel
													type='button'
													icon={iconCancelar}
												>
													{textCancelar || 'Cancelar'}
												</Button>
												{confirmar && (
													<Button
														type='submit'
														primary
														icon={iconConfirmar}
													>
														{textConfirmar
															|| 'Confirmar'}
													</Button>
												)}
												{isVisualizarTransacao && (
													<label>Atualizada em: {dataAlteracao || '-'}</label>
												)}
											</FooterStyle>
										</div>
									</ModalFormContext.Provider>
								</Form>
							)}
						</Formik>
						<WidgetDialog
							title={modalConfirmarCancelarTitulo}
							isOpen={this.state.isCancelConfirmOpen}
							textCancelar='Não'
							textConfirmar='Sim'
							mensagem={modalConfirmarCancelarCorpo}
							cancelar={() => {
								this.setState({ isCancelConfirmOpen: false });
							}}
							confirmar={() => {
								this.setState({ isCancelConfirmOpen: false });
								cancelar();
							}}
						/>
					</ModalBody>
				</Modal>
			</React.Fragment>
		);
	}
}

export default WidgetModalForm;
